module.exports = __webpack_public_path__ + "static/img/ali.b8865838.png";